<template>
    <div class="container">
        <!-- <el-button type="primary" style="width: 100px;height: 40px;margin-bottom: 20px" class="btnColor" @click="addFile()">添加文件</el-button> -->
        <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
            <el-form-item label="添加时间:" style="text-align: center">
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="开始时间" v-model="form.start_time"
                                    style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="结束时间" v-model="form.end_time"
                                    style="width: 100%;"></el-date-picker>
                </el-col>
            </el-form-item>
            <el-form-item label="文件分类:" style="text-align: center">
                <el-col :span="11">
                    <el-select clearable v-model="form.category_id1"  @change="selectCateOne" placeholder="请选择一级分类">
                        <el-option v-for=" i in categoryOne" :key="i.id" :label="i.name"
                                   :value="i.id"></el-option>
                    </el-select>

                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                    <el-select clearable v-model="form.category_id2"  placeholder="请选择二级分类">
                        <el-option v-for=" i in categoryTwo" :key="i.id" :label="i.name"
                                   :value="i.id"></el-option>
                    </el-select>
                </el-col>
            </el-form-item>
            <el-form-item label="关键词:">
                <el-input v-model="form.title" clearable placeholder="文件名称，文件描述"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSearch()">搜索</el-button>
            </el-form-item>
        </el-form>

        <el-table
                ref="multipleTable"
                :data="tableData"
                border
                stripe
                height="350"
                @selection-change="handleSelectionChange"
                style="width: 100%">
            <!-- <el-table-column
                    type="selection"
                    width="55"
                    fixed>
            </el-table-column> -->
            <!-- <el-table-column
                    label="文件编号"
                    width="80"
                    prop="document_id"
                    fixed
            >
            </el-table-column> -->
            <el-table-column
                    prop="category_name"
                    label="文件分类"
                  
                    >
            </el-table-column>
            <el-table-column
                    prop="name"
                    label="文件名称"
                 
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="desc"
                    label="文件描述"
                    show-overflow-tooltip>
            </el-table-column>
            <!-- <el-table-column
                    prop="remarks"
                    label="备注"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="sort"
                    label="排序"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="created_at"
                    label="添加时间"
                    show-overflow-tooltip>
            </el-table-column> -->
            <!-- <el-table-column
                    prop="downloads"
                    label="下载次数"
                    show-overflow-tooltip>
            </el-table-column> -->
            <el-table-column
                    fixed="right"
                    prop=""
                    label="操作"
                    width="180"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <!-- <el-button type="text" size="small" @click="edit(scope.row.document_id)">修改</el-button>
                    <el-button type="text" size="small" @click="del(scope.row.document_id)">删除</el-button> -->
                    <el-button type="text" size="small" @click="download(scope.row.document_id)">下载</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- <el-button type="primary" style="width: 100px;height: 40px;margin: 20px" @click="delMulti()">
            批量删除
        </el-button> -->
        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize">
        </el-pagination>

    </div>
</template>

<script>
    export default {
        name: "liabrary-list",
        data() {
            return {
                form:{
                    start_time:'',
                    end_time:'',
                    title:'',
                    category_id1:'',
                    category_id2:'',
                },
                categoryOne:[],
                categoryTwo:[],
                tableData:[

                ],
                multipleSelection:[],
                pageNo: 1,
                pageSize: 20,
                totalSize: 0,

            }
        },
        methods:
            {
                // 文件下载
                download(id){
                    var url='/documents/'+id+'/download'
                       this.$get('logistics',url, {
                        lang:'',
                      
                    }).then(res => {
                        console.log(res)
                        window.open(res.data.download_url)
                    }).catch(function (error) {
                        
                    });
                },
                // 获取分类
                getCataOne(){
                    this.$get('logistics','/category.one', {
                        lang:'',
                        type:2
                    }).then(res => {
                        this.categoryOne = res.data;
                    }).catch(function (error) {
                        console.log(error);
                    });
                },
                //选择一级分类
                selectCateOne(val){
                    this.form.category_id1 = val;
                    this.categoryTwo = [];
                    this.form.category_id2 = '';
                    this.getCateTwo();
                },
                getCateTwo(){
                    this.$get('logistics','/category.two', {
                        lang:'',
                        type:2,
                        pid:this.form.category_id1
                    }).then(res => {
                        this.categoryTwo = res.data;
                    }).catch(function (error) {
                        console.log(error);
                    });
                },
                onSearch(){
                    let beginstr = '', endstr = '',cateId = '';
                    if(this.form.start_time){
                        beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD")
                    }
                    if(this.form.end_time){
                        endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
                    }
                    if(this.form.category_id2){
                        cateId =this.form.category_id2;
                    }else{
                        cateId = this.form.category_id1 || '';
                    }
                    this.loading = true;
                    this.$get('logistics', '/documents', {
                        lang:'',
                        start_time:beginstr,
                        end_time:endstr,
                        category_id:cateId,
                        keywords:this.form.title,
                        per_page:this.pageSize,
                        page:this.pageNo
                    }).then(res => {
                        this.loading = false;
                        this.tableData = res.data;
                        this.totalSize = res.meta.total;
                    }).catch(function (error) {
                        this.loading = false;
                        console.log(error);
                    });
                },
                /*分页*/
                handleSizeChange(val) {
                    this.pageSize = val;
                    this.pageNo = 1;
                    this.onSearch();
                },
                handleCurrentChange(val) {
                    this.pageNo = val;
                    this.onSearch();
                },
                handleSelectionChange(val) {
                    this.multipleSelection = val;
                },
                addFile(){
                    this.$router.push({name:'addFile'});
                },
                edit(id){
                    this.$router.push({name:'addFile',query:{
                            document_id:id
                        }});

                },

                del(id){
                    this.$confirm('确定要删除吗？；可多选批量删除', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let delArr = [];
                        delArr.push(id);
                        this.$post('logistics', '/documents', {
                            lang:'',
                            _method:'DELETE',
                            document_id:delArr
                        }).then(res => {
                            this.$message({
                                type: 'success',
                                message: '删除成功'
                            });
                            this.onSearch();

                        }).catch(error =>{
                            this.$message({
                                type: 'error',
                                message: error.message
                            });

                        });
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                },
                //批量删除
                delMulti(){
                    if(this.multipleSelection.length == 0){
                        this.$message.error('请勾选数据...');
                        return;
                    }
                    this.$confirm('确定要删除吗？可多选批量删除?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let delArr = [];
                        for(var i =0; i < this.multipleSelection.length;i++){
                            delArr.push(this.multipleSelection[i].document_id);
                        }
                        this.$post('logistics', '/documents', {
                            lang:'',
                            _method:'DELETE',
                            document_id:delArr
                        }).then(res => {
                            this.$message({
                                type: 'success',
                                message: '删除成功'
                            });
                            this.onSearch();

                        }) .catch(error =>{
                            this.$message({
                                type: 'error',
                                message: error.message
                            });

                        });
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                },
            },
        created() {
            this.getCataOne();
            this.onSearch();
        },
    }
</script>

<style lang="scss" scoped>

</style>